import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./App.css";
import "./fonts.css";
import 'bootstrap/dist/css/bootstrap.css';
import './styles/custom-btsp.scss';
import App from './App';
import { BrowserRouter } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);
